import * as Types from '../constants/Types';

export const getListRedisCache = () => ({ type: Types.CACHE_LIST_ACTION });

export const setRedisKeyAction = (rediscache) => ({ type: Types.CACHE_LIST_SUCCESS, rediscache });

export const deleteRedisKeyAction = (params) => ({ type: Types.CACHE_DELETE_ACTION, params });
